<template>
  <div v-if="!env.inWeixinMini" class="title-bar" :class="{ 'in-dp': env.app === 'dianping-nova' }">
    <div class="back" @click="closePage"></div>
    <div class="title">{{ title }}&nbsp;</div>
    <div v-show="showCustomerService" class="customer-service">
      <span class="customer-service-icon" @click="handleServiceClick" />
    </div>
    <span
      v-if="showQuestion"
      class="right"
      :style="{ background: `url(${questionButton})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }"
      @click="toClickRight"
    ></span>
    <span
      v-if="showMore"
      class="right"
      :style="{ background: `url(${moreButton})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }"
      @click="toClickRight"
    ></span>
    <span v-if="rightText" class="right-text" @click="toClickRight">{{ rightText }}</span>
  </div>
  <div v-else>{{ setTitle() }}</div>
</template>

<script lang="ts">
import Vue from 'vue';
import { bridge, env } from '@/common';
import { navRightButton } from '@/common/constant';
import { navComponent } from '@/utils/createNav';

export default Vue.extend({
  name: 'TitleBar',
  props: {
    title: {
      default: '',
      type: String,
    },
    showQuestion: {
      default: false,
      type: Boolean,
    },
    closeType: {
      type: Number,
      default: 1, // 1关闭，2根据是否native确定返回逻辑
    },
    showMore: {
      default: false,
      type: Boolean,
    },
    otherHandle: {
      default: false,
      type: Boolean,
    },
    rightText: {
      default: '',
      type: String,
    },
    customerServiceUrl: {
      default: '',
      type: String,
    },
  },
  data: () => {
    return {
      env,
      moreButton: navRightButton,
      questionButton: 'https://p0.meituan.net/wxapp/4aed7aca2563f9ceea46a5aff7d47df01259.png',
    };
  },
  computed: {
    showCustomerService(): boolean {
      return !!(this.customerServiceUrl && this.customerServiceUrl.trim() !== '');
    },
  },
  mounted() {
    const dom = document.body || document.documentElement;
    dom.removeEventListener('click', this.clickOtherCloseFunc);
    dom.addEventListener('click', this.clickOtherCloseFunc);
  },
  methods: {
    handleServiceClick() {
      bridge.openPage(this.customerServiceUrl);
    },
    setTitle() {
      bridge.setTitle(this.title);
    },
    closePage() {
      if (this.otherHandle) {
        this.$emit('click-left');
        return;
      }
      if (this.closeType === 1) {
        bridge.closePage();
      } else {
        if (env.isNative) {
          bridge.closePage();
        } else {
          this.$router.back();
        }
      }
    },
    toClickRight() {
      this.$emit('to-click-right');
    },
    clickOtherCloseFunc(event: any) {
      if (event.target.className !== 'right' && navComponent.isOpen()) {
        navComponent.close();
      }
    },
  },
});
</script>

<style lang="less" scoped>
@import '../styles/vars.less';

.customer-service-icon {
  position: fixed;
  top: 0.2rem;
  width: 0.48rem;
  height: 0.48rem;
  right: 0.96rem; // 0.24rem(right间距) + 0.48rem(按钮宽度) + 0.24rem(间距)
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111111;
  cursor: pointer;
  background: url('../assets/icon-kefu.png') 100% / contain no-repeat;
}

.title-bar {
  position: fixed;
  top: 0;
  background: @theme-main-bg;
  z-index: 2;
}
.back {
  position: fixed;
  top: 0.2rem;
  width: 0.44rem;
  height: 0.44rem;
  left: 0.24rem;
  background: url('../assets/title-back.png') no-repeat;
  background-size: 100% 100%;
  z-index: 1;
}
.title {
  width: 100vw;
  text-align: center;
  font-size: 0.34rem;
  line-height: 0.48rem;
  color: #111111;
  font-weight: 700;
  padding: 0.2rem 0;
  transform: translateX(0.06rem);
}
.right {
  position: fixed;
  top: 0.2rem;
  width: 0.44rem;
  height: 0.44rem;
  right: 0.24rem;
  background-size: 0.4rem 0.4rem;
  z-index: 1;
  border: none;
}

.right-text {
  position: fixed;
  top: 0.24rem;
  height: 0.48rem;
  right: 0.24rem;
  font-size: 0.28rem;
  transform: translateY(-0.03rem);
}

@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .ios {
    .title-bar {
      padding-top: constant(safe-area-inset-top);
      padding-top: env(safe-area-inset-top);
    }
    .back {
      margin-top: constant(safe-area-inset-top);
      margin-top: env(safe-area-inset-top);
    }
    .right {
      margin-top: constant(safe-area-inset-top);
      margin-top: env(safe-area-inset-top);
    }
    .right-text {
      margin-top: constant(safe-area-inset-top);
      margin-top: env(safe-area-inset-top);
    }
    .customer-service-icon {
      margin-top: constant(safe-area-inset-top);
      margin-top: env(safe-area-inset-top);
    }
  }

  .ios {
    .in-dp.title-bar {
      padding-top: calc(constant(safe-area-inset-top) - 44px);
      padding-top: calc(env(safe-area-inset-top) - 44px);
    }
    .in-dp .back {
      margin-top: calc(constant(safe-area-inset-top) - 44px);
      margin-top: calc(env(safe-area-inset-top) - 44px);
    }
    .in-dp .right {
      margin-top: calc(constant(safe-area-inset-top) - 44px);
      margin-top: calc(env(safe-area-inset-top) - 44px);
    }
    .in-dp .right-text {
      margin-top: calc(constant(safe-area-inset-top) - 44px);
      margin-top: calc(env(safe-area-inset-top) - 44px);
    }
    .in-dp .customer-service-icon {
      margin-top: calc(constant(safe-area-inset-top) - 44px);
      margin-top: calc(env(safe-area-inset-top) - 44px);
    }
  }
}
</style>
